import styled from '@emotion/styled';
import { Button, colors, Modal, Text } from '@innovationdepartment/proxima-ui';
import ButtonGroup from 'ui/ButtonGroup';
import { FeedbackModalViewProps } from './types';

const ContentContainer = styled.div`
  padding: 24px 0;
  max-width: 422px;
  display: flex;
  flex-direction: column;
`;

const TextArea = styled.textarea`
  margin: 16px 0 4px;
  width: 380px;
  border-radius: 4px;
  border: 1px solid ${colors.neutral60};
  padding: 8px 12px;
  resize: none;
  height: 120px;

  color: ${colors.neutral100};
  font-family: Manrope, sans-serif;
  font-size: 14px;
  font-style: normal;
  line-height: 20px;
  letter-spacing: -0.07px;

  &::placeholder {
    color: ${colors.neutral60};
    font-family: Manrope, sans-serif;
    font-size: 14px;
    font-style: normal;
    line-height: 20px;
    letter-spacing: -0.07px;
  }
`;

const FeedbackModalView = (props: FeedbackModalViewProps) => {
  const { onClose, onSubmit, open, value, onChange, maxCharLength } = props;

  return (
    <Modal title="Share your feedback" open={open}>
      <ContentContainer>
        <Text variant="body1">Let us know why this response was not helpful</Text>
        <TextArea placeholder="Type feedback here" value={value} onChange={onChange} />
        {/* TODO(Jenky): come back to this */}
        <Text variant="body3">{maxCharLength} characters max</Text>
      </ContentContainer>
      <ButtonGroup>
        <Button
          size="small"
          label="Cancel"
          onClick={onClose}
          variant="outlined"
          color="secondary"
        />
        <Button
          className="proxima-button"
          variant="contained"
          size="small"
          label="Continue"
          onClick={onSubmit}
        />
      </ButtonGroup>
    </Modal>
  );
};

export default FeedbackModalView;
